module.exports = __webpack_public_path__ + "static/media/pay.f5dab129.png";